<template>
<PageShell wide>
  <div class="site-download-layout">
    <div>
      <h1 class="site-h1">Download GB WhatsApp APK (Latest Version)</h1>
      <p class="site-lead">
        Get the latest GB WhatsApp APK for Android with enhanced privacy controls, anti-ban improvements, custom themes, and advanced messaging features. Free download, fast installation, and regular updates.
      </p>

      <DownloadButton direct :label="'Download APK ' + site.version" />
      <ul class="site-chips">
        <li>✓ Updated {{ site.updated }}</li>
        <li>✓ {{ site.android }}</li>
        <li>✓ {{ site.size }}</li>
        <li>✓ Free Download</li>
      </ul>

      <h2 class="site-h2">How to Download GB WhatsApp</h2>
      <p>Downloading <router-link to="/">GB WhatsApp</router-link> only takes a few minutes.</p>
      <div class="site-steps">
        <div class="site-step">
          <div class="site-h3-style">Step 1</div>
          <p>Tap the Download APK button.</p>
        </div>
        <div class="site-step">
          <div class="site-h3-style">Step 2</div>
          <p>Wait until the APK file finishes downloading.</p>
        </div>
        <div class="site-step">
          <div class="site-h3-style">Step 3</div>
          <p>Locate the downloaded APK in your Downloads folder.</p>
        </div>
        <div class="site-step">
          <div class="site-h3-style">Step 4</div>
          <p>Proceed with the installation process.</p>
        </div>
      </div>

      <h2 class="site-h2">How to Install GB WhatsApp</h2>
      <p>Before installing, allow installations from unknown sources.</p>
      <div class="site-install-grid">
        <article v-for="(item, index) in installSteps" :key="item.text" class="site-install-card" :class="'is-' + item.tone">
          <span class="site-install-num">{{ index + 1 }}</span>
          <FeatureIcon :name="item.icon" />
          <p>{{ item.text }}</p>
        </article>
      </div>

      <h2 class="site-h2">Update to the Latest Version</h2>
      <p>Using the latest version helps improve compatibility and may reduce bugs found in older releases.</p>
      <p>Before updating:</p>
      <ul class="site-ul">
        <li>Back up chats.</li>
        <li>Download the newest APK.</li>
        <li>Install it over your current version.</li>
        <li>Verify your number if prompted.</li>
      </ul>
      <p>Your chats usually remain available when updating without uninstalling the app.</p>
    </div>

    <aside class="site-side-card">
      <div class="site-h3-style" style="margin-top:0">📱 GB WhatsApp APK</div>
      <p style="text-align:center;margin:0 0 8px">Latest Version</p>
      <p style="text-align:center;font-size:28px;font-weight:800;margin:0;color:#0b5c4a">{{ site.version }}</p>
      <p style="text-align:center;margin:8px 0 0">⭐ {{ site.downloads }} Downloads</p>
      <div class="site-side-meta">
        <div><span>Version</span><strong>{{ site.versionNumber }}</strong></div>
        <div><span>File Size</span><strong>{{ site.size }}</strong></div>
        <div><span>Android</span><strong>5.0+</strong></div>
        <div><span>Updated</span><strong>{{ site.updated }}</strong></div>
        <div><span>Developer</span><strong>{{ site.developer }}</strong></div>
        <div><span>Status</span><strong>{{ site.status }}</strong></div>
      </div>
      <DownloadButton direct label="Download APK" />
      <div class="site-side-icons">
        <span>🛡 Safe Scan</span>
        <span>⚡ Fast Download</span>
        <span>🔄 Latest Update</span>
      </div>
    </aside>
  </div>
</PageShell>
</template>

<script>
import PageShell from '@/components/PageShell.vue'
import DownloadButton from '@/components/DownloadButton.vue'
import FeatureIcon from '@/components/FeatureIcon.vue'
import { SITE } from '@/constants/site'

export default {
  name: 'Download',
  components: { PageShell, DownloadButton, FeatureIcon },
  data() {
    return {
      site: SITE,
      installSteps: [
        { icon: 'settings', tone: 'purple', text: 'Open Settings.' },
        { icon: 'install', tone: 'orange', text: 'Enable Install Unknown Apps.' },
        { icon: 'apk', tone: 'green', text: 'Open the APK file.' },
        { icon: 'check', tone: 'blue', text: 'Tap Install.' },
        { icon: 'update', tone: 'teal', text: 'Wait for installation.' },
        { icon: 'android', tone: 'green', text: 'Open GB WhatsApp.' },
        { icon: 'otp', tone: 'amber', text: 'Verify your phone number.' },
        { icon: 'restore', tone: 'orange', text: 'Restore your backup if available.' },
      ],
    }
  },
}
</script>
